/* eslint-disable */
import iframeResize from "@/directives/IframeResize";

import './scss/main.scss'
import 'spotlight.js/dist/spotlight.bundle.js';
import 'spotlight.js/dist/css/spotlight.min.css';
import VideoComponent from '@/components/VideoComponent.vue';
import NavigationComponent from '@/components/NavigationComponent.vue';
import NavigationToggle from '@/components/NavigationToggle.vue';
import Figures from '@/components/Figures.vue';
import MediaGallery from '@/components/MediaGallery.vue';
import PageDetail from '@/components/PageDetail.vue';
import CalendarList from '@/components/CalendarList.vue';
import ExternalForm from '@/components/ExternalForm.vue';
import FinderFilter from '@/components/FinderFilter.vue';
import ProjectFinder from '@/components/ProjectFinder.vue';
import VacancyFinder from '@/components/VacancyFinder.vue';
import NewsFinder from '@/components/NewsFinder.vue';
import DigitalServiceFinder from "@/components/DigitalServiceFinder.vue";
import SearchBar from '@/components/SearchBar.vue';
import SearchFinder from '@/components/SearchFinder.vue';
import {createApp, defineAsyncComponent, onMounted} from 'vue';
import store from '@/store';
import i18n from '@/i18n-setup';
import axios from "axios";
import filters from "@/utils/filters";
import openSocialShare from "@/directives/OpenSocialShare";
import {Navigation, Pagination} from 'swiper/modules';
import {register} from "swiper/swiper-element";
import {Swiper} from "swiper/types";

document.addEventListener("touchstart", function () {
}, false);

declare let __webpack_public_path__: string;
__webpack_public_path__ = _mgnl.contextPath + "/" + __webpack_public_path__;
/* eslint-enable */

// Set global language for every axios call
axios.defaults.headers.common['Accept-Language'] = _mgnl.language;

const app = createApp({
    components: {
        navigation: NavigationComponent,
        NavigationToggle,
        VideoComponent,
        Figures,
        EmployeeQuotes: defineAsyncComponent(() => import('@/components/EmployeeQuotes.vue')),
        MediaGallery,
        FinderFilter: FinderFilter,
        Loader: defineAsyncComponent(() => import('@/components/Loader.vue')),
        CalendarList,
        ExternalForm,
        ProjectFinder: ProjectFinder,
        VacancyFinder: VacancyFinder,
        NewsFinder: NewsFinder,
        DigitalServiceFinder: DigitalServiceFinder,
        PageDetail,
        OfficeList: defineAsyncComponent(() => import('@/components/OfficeList.vue')),
        SearchBar,
        SearchFinder,
        ServicePhases: defineAsyncComponent(() => import('@/components/ServicePhases.vue')),
        AnchorLinks: defineAsyncComponent(() => import('@/components/AnchorLinks.vue')),
        TabsWrapper: defineAsyncComponent(() => import('@/components/tabs/TabsWrapper.vue')),
        Tab: defineAsyncComponent(() => import('@/components/tabs/Tab.vue')),
        RelatedVacanciesList: defineAsyncComponent(() => import('@/components/vacancies/RelatedVacanciesList.vue')),
    },
    setup() {

        onMounted(() => {
            const swiperEls = document.querySelectorAll('swiper-container');
            const params = {
                modules: [Navigation, Pagination],
                on: {
                    afterInit: function (e: Swiper) {
                        // console.log('afterInit')
                        // setTimeout(() => {
                        //     e.update();
                        // }, 200);
                        // e.navigation.destroy();
                    }
                }
            }

            swiperEls.forEach((swiperEl) => {
                Object.assign(swiperEl, params);

                swiperEl.initialize();

                // swiperEl.swiper.on('beforeSlideChangeStart', function(e: Swiper) {
                //     console.log('beforeSlideChangeStart')
                //     console.log(e.activeIndex)
                //     console.log(e.realIndex)
                // })
                //
                // swiperEl.swiper.on('beforeTransitionStart', function(e: Swiper) {
                //     console.log('beforeTransitionStart')
                //     console.log(e.activeIndex)
                //     console.log(e.realIndex)
                // })

                swiperEl.swiper.on('navigationPrev', function(e: Swiper) {
                    console.log('navigationPrev')
                    console.log(e.activeIndex)
                    console.log(e.realIndex)
                })

                swiperEl.swiper.on('slideChange', function(e: Swiper) {
                    console.log('slide change')
                    console.log(e.activeIndex)
                    console.log(e.realIndex)
                    // setTimeout(()=> {
                    //     swiperEl.swiper.update();
                    // }, 200)
                })

                // setTimeout(()=> {
                //     swiperEl.swiper.update();
                // }, 200)
            })
        })
    }
});

app.config.performance = true;
app.config.compilerOptions.comments = true;
app.config.globalProperties.$filters = filters;

app.use(store);
app.use(i18n);

app.directive('open-social-share', openSocialShare)
app.directive('resize', iframeResize);

register();
app.mount('#app');